import React from 'react';
import { Box } from '@bcp-nextgen-dx-component-factory/accolade-design-system';
import { ComponentInfo, IntegratedSolutionCard } from '@components';
import { rem } from '@helpers';
import { useHasIntegratedSolution, useIsOperator } from '@store';

export const IntegratedSolutionCardPlaceholder: React.FC = () => {
	const hasIntegratedSolution = useHasIntegratedSolution();
	const isOperator = useIsOperator();

	return (
		<>
			{!hasIntegratedSolution && !isOperator && (
				<ComponentInfo name="IntegratedSolutionCardPlaceholder">
					<Box
						styles={{
							display: 'flex',
							flexDirection: 'column',
							margin: rem(24, 0, 0, 0),
						}}
					>
						<IntegratedSolutionCard />
					</Box>
				</ComponentInfo>
			)}
		</>
	);
};
